import apiClient from '../lib/apiClient';

/**
 * POST /auth/login
 * @param {{ email: string, password: string }} payload
 */
export const loginApi = (payload) =>
  apiClient('/auth/host-login', { method: 'POST', body: payload });

/**
 * POST /auth/register
 * @param {{
 *   first_name: string,
 *   middle_name: string,
 *   last_name: string,
 *   email: string,
 *   password: string,
 *   dob: string,          // "YYYY-MM-DD"
 *   country_code: string, // "+91"
 *   phone_number: string,
 * }} payload
 */
export const registerApi = (payload) =>
  apiClient('/auth/register-host', { method: 'POST', body: payload });

/**
 * POST /auth/verify-otp
 * @param {{ email: string, otp: string }} payload
 */
export const verifyOtpApi = (payload) =>
  apiClient('/auth/verify-otp', { method: 'POST', body: payload });

/**
 * POST /auth/resend-otp
 * @param {{ email: string }} payload
 */
export const resendOtpApi = (payload) =>
  apiClient('/auth/resend-otp', { method: 'POST', body: payload });
